<template>
  <div class="w-full bg-white border border-b-0 border-gray-300">
    <div class="hidden px-3 py-2 pt-4 text-lg font-bold leading-tight xl:block font-lufthansa-head">
      {{ tr('components.sales.summary.title') }}
    </div>

    <div class="text-sm border-b-2 border-secondary md:text-base xl:text-lg xl:border-b-3">
      <div class="flex justify-between px-3 py-3">
        <div class="mr-3 font-bold">
          {{ tr('components.sales.summary.totalValue') }}
        </div>
        <div class="flex-shrink-0 font-bold">
          {{ purchase.voucherDenominationCents | formatCurrency(currency) }}
        </div>
      </div>

      <div class="flex justify-between px-3 py-3 border-t border-gray-100">
        <div class="mr-3">
          {{ tr('components.sales.summary.totalDue') }}
        </div>
        <div class="flex-shrink-0">
          {{ $store.getters['sales/amountToPayInCents'] | formatCurrency(currency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherAmountSummary from '~brand-components/base/sale/voucher-amount-summary'

export default VoucherAmountSummary.extend()
</script>
